import React, { FC } from 'react'
import { Field } from 'formik'
import SelectField from 'civic-champs-shared/formik/components/SelectField'
import { QuestionType } from 'civic-champs-shared/question-sets/types'
import {
  getTargetOptionsForQuestionType,
  showsQuestionTargetField,
} from 'civic-champs-shared/question-sets/question-target'

interface QuestionTargetFieldProps {
  index: number
  questionType?: QuestionType
  disabled?: boolean
}

const QuestionTargetField: FC<QuestionTargetFieldProps> = ({ index, questionType, disabled }) => {
  if (!showsQuestionTargetField(questionType)) {
    return null
  }

  return (
    <Field
      name={`questions[${index}].target`}
      component={SelectField}
      label="Sync answer to"
      options={getTargetOptionsForQuestionType(questionType)}
      disabled={disabled}
    />
  )
}

export default QuestionTargetField
